import "./App.css";
import Form from "./components/Form.js/Form";
import Header from "./components/Header/Header";

function App() {
  return (
    <div className="App">
      <Header />
      <Form />
    </div>
  );
}

export default App;
